<template lang="pug">
pr-wrapper.interact.animated(fs, bg, bgo=".5", :zi="index", nv-sleep-protect, v-visible="activated")
  pr-wrapper.interact-container.animated.d-flex.flex-column.justify-content-center(fs, bg, zi="1", :class="position")
    .interact-header.px-5.pt-5.pb-4(ref="header")
      .d-flex.flex-column(v-if="payload.title")
        pr-subtitle(size="medium") {{ payload.title }}
        pr-text.mt-2.small.text-muted(v-show="payload.detail") {{ payload.detail }}
      .d-flex.flex-column(v-else)
        pr-text.mt-2(size="medium") {{ payload.detail }}
    .interact-scope.overflow-hidden(v-nv:scope="'interact'", data-scroll="center", nv-exit-protect, @nv-exit="close", ref="scope")
      .scroll-container.position-relative.py-2(ref="body")
        .interact-form(v-show="payload.type==='prompt'")
          .form-item-container.input(v-for="(input, name) in forms")
            component.input.bordered(
              :is="`pr-${input.type}`",
              :value.sync="input.value",
              :label="input.label",
              :floated="input.floated",
              :fluid="input.fluid",
              :icon="input.icon",
              :options="input.options",
              :multiple="input.multiple",
              :id="input.id"
            )
        .button-container
          pr-text.small.mt-2.text-muted(v-show="hasError") {{ $t("Please fill all the fields marked with") }}
            icon.icon.error.ml-2(:icon="'fas exclamation-circle'")
          pr-button.themed.scale-xs.mt-4.mb-3.w-100.border(v-nv, outline, v-show="payload.okButton", @nv-enter="done") {{ payload.okButton }}
          pr-button.themed.scale-xs.w-100.border(v-nv, outline, v-show="payload.cancelButton", @nv-enter="close") {{ payload.cancelButton }}
    .interact-footer.p-3(ref="footer")
</template>

<script>
export default {
  name: "interact",
  data() {
    return {
      forms: {},
      requireds: [],
      hasError: null,
      activated: false,
      payload: {},
      lastNavigation: null,
      index: "0"
    }
  },
  computed: {
    position() {
      if (!this.payload.options || !this.payload.options.position) return false

      return {
        left: this.payload.options.position === "left",
        right: this.payload.options.position === "right",
        activated: this.activated
      }
    }
  },
  watch: {
    activated(nval) {
      this.$emit("activate", { name: this.$options.name, state: nval })
      this.index = nval ? "102" : "0"
    }
  },
  mounted() {
    window.this_ = this
    _$.vue.$on("interact", this.activate)
    _$.vue.$on("beforeRoute", () => this.close("abort"))
  },
  methods: {
    async activate(payload) {
      if (!payload) return this.close("abort")
      else if (payload === "skip") return this.close()

      if (!this.validatePayload(payload)) return false
      if (this.activated) this.payload.reject()

      _$.vue.$emit("keyboard", "skip")
      _$.vue.$emit("dropdown", "skip")
      _$.vue.$emit("sidepane", "skip")

      await _$.sleep(250)
      this.payload = payload

      await this.convertPayload()
      await this.$nextTick()

      this.lastNavigation = this.lastNavigation || { current: _$.nav.getCurrentScope(), prev: _$.nav.getPrevScope() }
      if (this.$refs.header.offsetHeight + this.$refs.body.offsetHeight + this.$refs.footer.offsetHeight > window.innerHeight)
        this.$refs.scope.style.maxHeight = window.innerHeight - this.$refs.header.offsetHeight - this.$refs.footer.offsetHeight + "px"
      else this.$refs.scope.style.maxHeight = "none"

      await _$.nav.sync("interact", true)
      await _$.sleep(200)
      this.activated = true
    },
    validatePayload(payload) {
      let validate = true

      if (typeof payload !== "object") validate = false
      if ((!payload.title && !payload.detail) || !payload.resolve || !payload.reject) validate = false
      if (typeof payload.resolve !== "function") validate = false
      if (typeof payload.reject !== "function") validate = false

      if (payload.type === "prompt") {
        let result = payload.data.map(input => {
          if (["input", "select", "choose", "time-selector", "switch"].indexOf(input.type) < 0) return false
          if (input.type === "select" && !Array.isArray(input.data)) return false
          if (!input.id && !input.label) return false
          return true
        })

        result = result.some(field => !field)
        if (result) validate = false
      }

      if (!validate && typeof payload === "object" && payload.reject) payload.reject()

      return validate
    },
    async convertPayload() {
      if (this.payload.type === "alert") {
        this.payload.okButton = this.$t("Done")
        this.payload.cancelButton = null
      } else if (this.payload.type === "confirm") {
        this.payload.okButton = this.payload.data[0] || this.$t("Confirm")
        this.payload.cancelButton = this.payload.data[1] || this.$t("Cancel")
      } else {
        this.payload.okButton = this.$t("Done")
        this.payload.cancelButton = this.$t("Cancel")
        await this.createForm()
      }
    },
    async createForm() {
      this.forms = {}
      this.requireds = []
      await this.$nextTick()

      for (const field of this.payload.data) {
        let field_id = field.id ? field.id : field.label.snakeCase()

        let convertedValue
        if (field.type === "switch") convertedValue = _$.true(field.value)
        else convertedValue = field.value || ""

        this.$set(this.forms, field_id, {
          value: convertedValue,
          label: this.$t(field.label),
          type: field.type,
          floated: field.floated,
          fluid: field.fluid,
          icon: field.icon,
          options: field.data,
          multiple: field.multiple,
          id: field_id
        })
        if (!field.optional && field.type !== "switch") this.requireds.push(field_id)
      }
      return true
    },
    done() {
      if (["alert", "confirm"].indexOf(this.payload.type) >= 0) this.close(true, true)

      let result = {},
        validation = this.requireds.map(key => {
          if (!this.forms[key]) return true
          const item = this.forms[key]
          if (!document.getElementById(item.id)) return true
          document.getElementById(item.id).classList.remove("hasError")

          if (!this.forms[key].value) {
            document.getElementById(item.id).classList.add("hasError")
            return false
          }

          return true
        })

      validation = validation.some(field => !field)
      if (validation) {
        this.hasError = true
        return false
      } else this.hasError = null

      Object.keys(this.forms).forEach(key => {
        let form = this.forms[key]
        result[key] = { id: key, label: key.capitalize(), value: form.value }
      })

      if (Object.keys(this.forms).length) this.close(true, result)
      else this.close()
    },
    close(reason, resolve) {
      if (!this.activated) return false

      if (this.lastNavigation && reason !== "abort") {
        if (this.lastNavigation.current) _$.nav.changeScope(this.lastNavigation.current.name)
        _$.nav._prevScope = this.lastNavigation.prev
      }

      this.lastNavigation = null
      this.activated = false

      if (resolve) return this.payload.resolve(resolve)
      else return this.payload.reject()
    }
  }
}
</script>

<style lang="scss" scoped>
.interact-container {
  width: 450px;
  box-shadow: 10px 0px 15px 2px rgba(0, 0, 0, 0.5);
  right: unset;
  left: -465px;

  &.left {
    left: -415px;
    right: auto !important;
    &.activated {
      left: 0;
    }
  }

  &.right {
    box-shadow: -10px 0px 15px 2px rgba(0, 0, 0, 0.5);
    right: -465px;
    left: auto !important;
    &.activated {
      right: 0;
    }
  }

  .interact-header {
    position: relative;
    z-index: 1;
  }
  .interact-scope {
    max-height: 0;

    .button-container {
      padding: 0 3rem;
    }
    .interact-form {
      padding: 1rem 0;
      .form-item-container {
        margin-bottom: -1px;

        .input {
          border-left: 0;
          border-right: 0;
          padding: 1.25rem 3rem;
          position: relative;

          &.nv-el-current {
            z-index: 1;
            //border-right: 3px;
          }
        }
      }
    }
  }
}
</style>
